<template>
  <div id="messageboard">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'messageboard'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/messageboard/Messageboard.vue